export const languageMap: Record<string, Record<string, Record<string, string>>> = {
  IN: {
    Hindi: {
      name: 'नाम',
      mobileNumber: 'मोबाइल नंबर',
      whatsappNumber: 'व्हाट्सएप नंबर',
      email: 'ईमेल',
      pinCode: 'पिनकोड',
      state: 'राज्य',
      district: 'जिला',
      city: 'शहर',
      sendOtp: 'OTP भेजें',
      resendOtp: 'OTP पुनः भेजें',
      enterOtp: 'कृपया 6 अंकों का कोड दर्ज करें',
      continue: 'जारी रखें',
      errorMessage: 'नाम, मोबाइल नंबर, पिनकोड और शहर खाली नहीं हो सकते।',
      errorFailedOTP: 'ओटीपी भेजने में असफल।'
    },
    Bengali: {
      name: 'নাম',
      mobileNumber: 'মোবাইল নম্বর',
      whatsappNumber: 'হোয়াটসঅ্যাপ নম্বর',
      email: 'ইমেল',
      pinCode: 'পিনকোড',
      state: 'রাজ্য',
      district: 'জেলা',
      city: 'শহর',
      sendOtp: 'OTP পাঠান',
      resendOtp: 'OTP পুনরায় পাঠান',
      enterOtp: 'দয়া করে ৬ ডিজিটের কোড লিখুন',
      continue: 'অগ্রসর হোন',
      errorMessage: 'নাম, মোবাইল নম্বর, পিনকোড এবং শহর খালি রাখা যাবে না।',
      errorFailedOTP: 'ওটিপি পাঠাতে ব্যর্থ হয়েছে'
    },
    Telugu: {
      name: 'పేరు',
      mobileNumber: 'మొబైల్ నంబర్',
      whatsappNumber: 'వాట్సాప్ నంబర్',
      email: 'ఇమెయిల్',
      pinCode: 'పిన్ కోడ్',
      state: 'రాష్ట్రం',
      district: 'జిల్లా',
      city: 'నగరం',
      sendOtp: 'OTP పంపండి',
      resendOtp: 'OTP మళ్లీ పంపండి',
      enterOtp: 'దయచేసి 6 అంకెల కోడ్ నమోదు చేయండి',
      continue: 'తదుపరి',
      errorMessage: 'పేరు, మొబైల్ నంబర్, పిన్ కోడ్ మరియు నగరం ఖాళీగా ఉండకూడదు.',
      errorFailedOTP: 'OTP పంపించడంలో విఫలమైంది.'
    },
    Marathi: {
      name: 'नाव',
      mobileNumber: 'मोबाइल नंबर',
      whatsappNumber: 'व्हाट्सअॅप नंबर',
      email: 'ईमेल',
      pinCode: 'पिनकोड',
      state: 'राज्य',
      district: 'जिल्हा',
      city: 'शहर',
      sendOtp: 'OTP पाठवा',
      resendOtp: 'OTP पुन्हा पाठवा',
      enterOtp: 'कृपया 6 अंकी कोड टाका',
      continue: 'सुरू ठेवा',
      errorMessage: 'नाव, मोबाइल नंबर, पिनकोड आणि शहर रिकामे ठेऊ शकत नाहीत.',
      errorFailedOTP: 'ओटीपी पाठवू शकले नाही.'
    },
    Tamil: {
      name: 'பெயர்',
      mobileNumber: 'மொபைல் எண்',
      whatsappNumber: 'வாட்ஸ்அப் எண்',
      email: 'இமெயில்',
      pinCode: 'பின்கோடு',
      state: 'மாநிலம்',
      district: 'மாவட்டம்',
      city: 'நகரம்',
      sendOtp: 'OTP அனுப்பவும்',
      resendOtp: 'OTP மறுபடியும் அனுப்பவும்',
      enterOtp: 'தயவுசெய்து 6 இலக்க கோடு உள்ளிடவும்',
      continue: 'தொடரவும்',
      errorMessage: 'பெயர், மொபைல் எண், பின்கோடு மற்றும் நகரம் காலியாக இருக்க முடியாது.',
      errorFailedOTP: 'OTP அனுப்ப முடியவில்லை.'
    },
    Gujarati: {
      name: 'નામ',
      mobileNumber: 'મોબાઇલ નંબર',
      whatsappNumber: 'વોટ્સએપ નંબર',
      email: 'ઇમેઇલ',
      pinCode: 'પિનકોડ',
      state: 'રાજ્ય',
      district: 'જિલ્લો',
      city: 'શહેર',
      sendOtp: 'OTP મોકલો',
      resendOtp: 'OTP ફરીથી મોકલો',
      enterOtp: 'કૃપા કરીને 6 અંક નો કોડ દાખલ કરો',
      continue: 'ચાલુ રાખો',
      errorMessage: 'નામ, મોબાઇલ નંબર, પિનકોડ અને શહેર ખાલી હોવા જોઈએ નહીં.',
      errorFailedOTP: 'ઓટિપિ મોકલવામાં નિષ્ફળ.'
    },
    Urdu: {
      name: 'نام',
      mobileNumber: 'موبائل نمبر',
      whatsappNumber: 'واٹس ایپ نمبر',
      email: 'ای میل',
      pinCode: 'پن کوڈ',
      state: 'صوبہ',
      district: 'ضلع',
      city: 'شہر',
      sendOtp: 'OTP بھیجیں',
      resendOtp: 'OTP دوبارہ بھیجیں',
      enterOtp: 'براہ کرم 6 ہندسوں کا کوڈ درج کریں',
      continue: 'جاری رکھیں',
      errorMessage: 'نام، موبائل نمبر، پن کوڈ اور شہر خالی نہیں ہو سکتے۔',
      errorFailedOTP: 'او ٹی پی بھیجنے میں ناکام رہا۔'
    },
    Punjabi: {
      name: 'ਨਾਮ',
      mobileNumber: 'ਮੋਬਾਈਲ ਨੰਬਰ',
      whatsappNumber: 'ਵਟਸਐਪ ਨੰਬਰ',
      email: 'ਈਮੇਲ',
      pinCode: 'ਪਿਨਕੋਡ',
      state: 'ਰਾਜ',
      district: 'ਜ਼ਿਲਾ',
      city: 'ਸ਼ਹਿਰ',
      sendOtp: 'OTP ਭੇਜੋ',
      resendOtp: 'OTP ਦੁਬਾਰਾ ਭੇਜੋ',
      enterOtp: 'ਕਿਰਪਾ ਕਰਕੇ 6 ਅੰਕਾਂ ਦਾ ਕੋਡ ਦਰਜ ਕਰੋ',
      continue: 'ਜਾਰੀ ਰੱਖੋ',
      errorMessage: 'ਨਾਮ, ਮੋਬਾਈਲ ਨੰਬਰ, ਪਿਨਕੋਡ ਅਤੇ ਸ਼ਹਿਰ ਖਾਲੀ ਨਹੀਂ ਹੋ ਸਕਦੇ।',
      errorFailedOTP: 'ਓਟੀਪੀ ਭੇਜਣ ਵਿੱਚ ਅਸਫਲ।'
    },
    Malayalam: {
      name: 'പേര്',
      mobileNumber: 'മൊബൈൽ നമ്പർ',
      whatsappNumber: 'വാട്സ്ആപ്പ് നമ്പർ',
      email: 'ഇമെയിൽ',
      pinCode: 'പിന്‍കോഡ്',
      state: 'സംസ്ഥാനം',
      district: 'ജില്ല',
      city: 'നഗരം',
      sendOtp: 'OTP അയക്കുക',
      resendOtp: 'OTP പുന: അയക്കുക',
      enterOtp: 'ദയവായി 6 അംകമായ കോഡ് നൽകുക',
      continue: 'മുന്നോട്ട് പോവുക',
      errorMessage: 'പേര്, മൊബൈൽ നമ്പർ, പിന്‍കോഡ്, നഗരവും ശൂന്യമായിരിക്കരുത്.',
      errorFailedOTP: 'ഒടിപിഎസ് അയയ്ക്കാൻ പരാജയപ്പെട്ടു.'
    },
    Odia: {
      name: 'ନାମ',
      mobileNumber: 'ମୋବାଇଲ୍ ନମ୍ବର',
      whatsappNumber: 'ହୋୟାଟସ୍ଏପ୍ ନମ୍ବର',
      email: 'ଇମେଲ୍',
      pinCode: 'ପିନକୋଡ୍',
      state: 'ରାଜ୍ୟ',
      district: 'ଜିଲ୍ଲା',
      city: 'ସହର',
      sendOtp: 'OTP ପଠାନ୍ତୁ',
      resendOtp: 'OTP ପୁନଃ ପଠାନ୍ତୁ',
      enterOtp: 'ଦୟାକରି 6 ଆଙ୍କର କୋଡ୍ ଦାଖଲ କରନ୍ତୁ',
      continue: 'ଜାରୀ ରଖନ୍ତୁ',
      errorMessage: 'ନାମ, ମୋବାଇଲ୍ ନମ୍ବର, ପିନକୋଡ୍ ଏବଂ ସହର ଖାଲି ନହୋଇପାରିବେ।',
      errorFailedOTP: 'OTP ପଠାଇବାରେ ବିଫଳ ହେଲା।'
    },
    Kannada: {
      name: 'ಹೆಸರು',
      mobileNumber: 'ಮೊಬೈಲ್ ಸಂಖ್ಯೆ',
      whatsappNumber: 'ವಾಟ್ಸಾಪ್ ಸಂಖ್ಯೆ',
      email: 'ಇಮೇಲ್',
      pinCode: 'ಪಿನ್ ಕೋಡ್',
      state: 'ರಾಜ್ಯ',
      district: 'ಜಿಲ್ಲೆ',
      city: 'ನಗರ',
      sendOtp: 'OTP ಕಳುಹಿಸಿ',
      resendOtp: 'OTP ಮರುಕಳುಹಿಸಿ',
      enterOtp: 'ದಯವಿಟ್ಟು 6 ಅಂಕಗಳ ಕೋಡ್ ನಮೂದಿಸಿ',
      continue: 'ಮುಂದೆ ಹೋಗಿ',
      errorMessage: 'ಹೆಸರು, ಮೊಬೈಲ್ ಸಂಖ್ಯೆ, ಪಿನ್ ಕೋಡ್ ಮತ್ತು ನಗರ ಖಾಲಿ ಇರಬೇಡಿ.',
      errorFailedOTP: 'ಒಟಿಪಿ ಕಳುಹಿಸಲು ವಿಫಲವಾಗಿದೆ.'
    },
    Assamese: {
      name: 'নাম',
      mobileNumber: 'মোবাইল নম্বৰ',
      whatsappNumber: 'হোৱাটচএপ নম্বৰ',
      email: 'ইমেইল',
      pinCode: 'পিনকোড',
      state: 'ৰাজ্য',
      district: 'জিলা',
      city: 'চহৰ',
      sendOtp: 'OTP পঠিয়াব',
      resendOtp: 'OTP পুনৰ পঠিয়াব',
      enterOtp: 'অনুগ্রহ কৰি 6 সংখ্যাৰ কোডটো সন্নিবিষ্ট কৰক',
      continue: 'অগ্ৰসর হওক',
      errorMessage: 'নাম, মোবাইল নম্বৰ, পিনকোড আৰু চহৰ খালি ৰাখিব নোৱাৰিব।',
      errorFailedOTP: 'OTP পঠিয়াবলৈ ব্যৰ্থ হলো।'
    },
  },

  AE: {
    Arabic: {
      name: 'الاسم',
      mobileNumber: 'رقم الجوال',
      whatsappNumber: 'رقم الواتساب',
      email: 'البريد الإلكتروني',
      pinCode: 'الرمز البريدي',
      state: 'الولاية',
      district: 'المنطقة',
      city: 'المدينة',
      sendOtp: 'إرسال OTP',
      resendOtp: 'إعادة إرسال OTP',
      enterOtp: 'يرجى إدخال الرمز المكون من 6 أرقام',
      continue: 'استمرار',
      errorMessage: 'الاسم، رقم الجوال، الرمز البريدي، والمدينة لا يمكن أن تكون فارغة.',
      errorFailedOTP: 'فشل في إرسال رمز التحقق.'
    }
  },

  SA: {
    Arabic: {
      name: 'الاسم',
      mobileNumber: 'رقم الجوال',
      whatsappNumber: 'رقم الواتساب',
      email: 'البريد الإلكتروني',
      pinCode: 'الرمز البريدي',
      state: 'الولاية',
      district: 'المنطقة',
      city: 'المدينة',
      sendOtp: 'إرسال OTP',
      resendOtp: 'إعادة إرسال OTP',
      enterOtp: 'يرجى إدخال الرمز المكون من 6 أرقام',
      continue: 'استمرار',
      errorMessage: 'الاسم، رقم الجوال، الرمز البريدي، والمدينة لا يمكن أن تكون فارغة.',
      errorFailedOTP: 'فشل في إرسال رمز التحقق.'
    },
  },
  BD: {
    Bengali: {
      name: 'নাম',
      mobileNumber: 'মোবাইল নম্বর',
      whatsappNumber: 'হোয়াটসঅ্যাপ নম্বর',
      email: 'ইমেল',
      pinCode: 'পিনকোড',
      state: 'রাজ্য',
      district: 'জেলা',
      city: 'শহর',
      sendOtp: 'OTP পাঠান',
      resendOtp: 'OTP পুনরায় পাঠান',
      enterOtp: 'দয়া করে ৬ ডিজিটের কোড লিখুন',
      continue: 'অগ্রসর হোন',
      errorMessage: 'নাম, মোবাইল নম্বর, পিনকোড এবং শহর খালি রাখা যাবে না।',
      errorFailedOTP: 'ওটিপি পাঠাতে ব্যর্থ হয়েছে'
    },
  },
  TH: {
    Thai: {
      name: 'ชื่อ',
      mobileNumber: 'หมายเลขโทรศัพท์มือถือ',
      whatsappNumber: 'หมายเลข WhatsApp',
      email: 'อีเมล',
      pinCode: 'รหัสไปรษณีย์',
      state: 'รัฐ',
      district: 'อำเภอ',
      city: 'เมือง',
      sendOtp: 'ส่ง OTP',
      resendOtp: 'ส่ง OTP ใหม่',
      enterOtp: 'กรุณากรอกรหัส 6 หลัก',
      continue: 'ดำเนินการต่อ',
      errorMessage: 'ชื่อ, หมายเลขโทรศัพท์มือถือ, รหัสไปรษณีย์ และเมืองไม่สามารถเว้นว่างได้.',
      errorFailedOTP: 'ส่ง OTP ไม่สำเร็จ'
    },
  },
  PH: {
      Filipino: {
        name: 'Pangalan',
        mobileNumber: 'Mobile Number',
        whatsappNumber: 'WhatsApp Number',
        email: 'Email',
        pinCode: 'Pincode',
        state: 'Estado',
        district: 'Distrito',
        city: 'Lungsod',
        sendOtp: 'Magpadala ng OTP',
        resendOtp: 'Ipadala muli ang OTP',
        enterOtp: 'Pakipasok ang 6 na digit na code',
        continue: 'Magpatuloy',
        errorMessage: 'Hindi pwedeng walang laman ang Pangalan, Mobile Number, Pincode, at Lungsod.',
        errorFailedOTP: 'Nabigong ipadala ang OTP'
      },
    },
    CI: {
      French: {
        name: 'Nom',
        mobileNumber: 'Numéro de téléphone mobile',
        whatsappNumber: 'Numéro WhatsApp',
        email: 'Email',
        pinCode: 'Code postal',
        state: 'État',
        district: 'District',
        city: 'Ville',
        sendOtp: 'Envoyer OTP',
        resendOtp: 'Renvoyer OTP',
        enterOtp: 'Veuillez entrer le code à 6 chiffres',
        continue: 'Continuer',
        errorMessage: 'Le nom, le numéro de mobile, le code postal et la ville ne peuvent pas être vides.',
        errorFailedOTP: 'Échec de l\'envoi du OTP'
      },
    },
    NP: {
      Nepali: {
        name: 'नाम',
        mobileNumber: 'मोबाइल नम्बर',
        whatsappNumber: 'व्हाट्सएप नम्बर',
        email: 'इमेल',
        pinCode: 'पिनकोड',
        state: 'राज्य',
        district: 'जिल्ला',
        city: 'सहर',
        sendOtp: 'OTP पठाउनुहोस्',
        resendOtp: 'OTP पुन: पठाउनुहोस्',
        enterOtp: 'कृपया 6 अङ्कको कोड प्रविष्ट गर्नुहोस्',
        continue: 'जारी राख्नुहोस्',
        errorMessage: 'नाम, मोबाइल नम्बर, पिनकोड र सहर खाली हुन सक्दैनन्।',
        errorFailedOTP: 'OTP पठाउन असफल भयो'
      },
    }
};

export 
const labelsMap: Record<string, { whatYouLike: string; option1: string; option2: string;
  CurrentlyDoing: string,
  Business: string,
  PrivateJob: string,
  GovermentJob: string,
  Student: string,
  SearchJob: string,
  Retired: string,
  Homemaker: string,
  submit: string
}> = {
  English: {
    whatYouLike: "What would you like to do?",
    option1: "Would you like to earn money by doing business without any investment?",
    option2: "Would you like to receive advice from us to improve and succeed in your current business?",
    CurrentlyDoing: 'What are you currently doing?',
    Business: 'Business',
    PrivateJob: 'Private job',
    GovermentJob: 'Government job',
    Student: 'Student',
    SearchJob: 'Looking for a job',
    Retired: 'Retired',
    Homemaker: 'Homemaker',
    submit: 'Submit'
  },
  Hindi: {
    whatYouLike: "आप क्या करना चाहते हैं?",
    option1: "क्या आप बिना किसी निवेश के व्यवसाय करके पैसा कमाना चाहते हैं?",
    option2:
      "क्या आप अपने वर्तमान व्यवसाय में सुधार और सफलता के लिए हमारी सलाह प्राप्त करना चाहते हैं?",
    CurrentlyDoing: 'आप वर्तमान में क्या कर रहे हैं?',
    Business: 'व्यवसाय',
    PrivateJob: 'निजी नौकरी',
    GovermentJob: 'सरकारी नौकरी',
    Student: 'छात्र',
    SearchJob: 'नौकरी की तलाश में',
    Retired: 'सेवानिवृत्त',
    Homemaker: 'गृहिणी',
    submit: 'जमा करें'
  },
  Telugu: {
    whatYouLike: "మీరు ఏమి చేయాలనుకుంటున్నారు?",
    option1:
      "మీరు పెట్టుబడి లేకుండా వ్యాపారం చేసి డబ్బు సంపాదించాలనుకుంటున్నారా?",
    option2:
      "మీ ప్రస్తుత వ్యాపారాన్ని మెరుగుపరచడానికి మా సలహా తీసుకోవాలనుకుంటున్నారా?",
    CurrentlyDoing: 'మీరు ప్రస్తుతం ఏమి చేస్తున్నారు?',
    Business: 'వ్యాపారం',
    PrivateJob: 'ప్రైవేట్ ఉద్యోగం',
    GovermentJob: 'ప్రభుత్వ ఉద్యోగం',
    Student: 'విద్యార్థి',
    SearchJob: 'ఉద్యోగాన్ని వెతుకుతున్నాను',
    Retired: 'రిటైర్డ్',
    Homemaker: 'గృహిణి',
    submit: 'సబ్మిట్ చేయండి'
  },
  Bengali: {
    whatYouLike: "আপনি কী করতে চান?",
    option1: "আপনি কি কোনো বিনিয়োগ ছাড়াই ব্যবসা করে অর্থ উপার্জন করতে চান?",
    option2:
      "আপনি কি আপনার বর্তমান ব্যবসার উন্নতির জন্য আমাদের পরামর্শ নিতে চান?",
    CurrentlyDoing: 'আপনি বর্তমানে কী করছেন?',
    Business: 'ব্যবসা',
    PrivateJob: 'প্রাইভেট চাকরি',
    GovermentJob: 'সরকারি চাকরি',
    Student: 'ছাত্র/ছাত্রী',
    SearchJob: 'চাকরির সন্ধানে',
    Retired: 'অবসরপ্রাপ্ত',
    Homemaker: 'গৃহিণী',
    submit: 'জমা দিন'
  }, Tamil: {
    whatYouLike: "நீங்கள் என்ன செய்ய விரும்புகிறீர்கள்?",
    option1: "முதலீடு இல்லாமல் வணிகம் செய்து பணம் சம்பாதிக்க விரும்புகிறீர்களா?",
    option2: "உங்கள் தற்போதைய வணிகத்தை மேம்படுத்த நமது ஆலோசனையை பெற விரும்புகிறீர்களா?",
    CurrentlyDoing: "நீங்கள் இப்போது என்ன செய்கிறீர்கள்?",
    Business: "வியாபாரம்",
    PrivateJob: "தனியார் வேலை",
    GovermentJob: "அரசு வேலை",
    Student: "மாணவன்/மாணவி",
    SearchJob: "வேலை தேடுபவர்",
    Retired: "ஓய்வு பெற்றவர்",
    Homemaker: "இல்லத்தரசி",
    submit: "சமர்ப்பி"
  }, Marathi: {
    whatYouLike: "तुम्हाला काय करायचं आहे?",
    option1: "तुम्हाला कोणतीही गुंतवणूक न करता व्यवसाय करून पैसे कमवायचे आहेत का?",
    option2: "तुमच्या सध्याच्या व्यवसायात सुधारणा करण्यासाठी आमचा सल्ला हवा आहे का?",
    CurrentlyDoing: "तुम्ही सध्या काय करत आहात?",
    Business: "व्यवसाय",
    PrivateJob: "खाजगी नोकरी",
    GovermentJob: "सरकारी नोकरी",
    Student: "विद्यार्थी",
    SearchJob: "नोकरी शोधत आहे",
    Retired: "सेवानिवृत्त",
    Homemaker: "गृहिणी",
    submit: "सबमिट करा"
  }, Gujarati : {
    whatYouLike: "તમે શું કરવું ઇચ્છો છો?",
    option1: "શું તમે કોઈ પણ રોકાણ વગર વ્યવસાય કરીને પૈસા કમાવા ઇચ્છો છો?",
    option2: "શું તમે તમારા હાલના વ્યવસાયમાં સુધારા માટે અમારી સલાહ ઇચ્છો છો?",
    CurrentlyDoing: "તમે હાલ શું કરી રહ્યા છો?",
    Business: "વ્યાવસાય",
    PrivateJob: "ખાસ નોકરી",
    GovermentJob: "સરકારી નોકરી",
    Student: "વિદ્યાર્થી",
    SearchJob: "નોકરીની શોધમાં",
    Retired: "રીટાયર",
    Homemaker: "ઘરેણી",
    submit: "સબમિટ"
  }, Urdu:{
    whatYouLike: "آپ کیا کرنا چاہتے ہیں؟",
    option1: "کیا آپ بغیر کسی سرمایہ کاری کے کاروبار کرکے پیسہ کمانا چاہتے ہیں؟",
    option2:
      "کیا آپ اپنے موجودہ کاروبار کو بہتر بنانے کے لیے ہماری مشورہ لینا چاہتے ہیں؟",
    CurrentlyDoing: "آپ اس وقت کیا کر رہے ہیں؟",
    Business: "کاروبار",
    PrivateJob: "نجی نوکری",
    GovermentJob: "سرکاری نوکری",
    Student: "طالب علم",
    SearchJob: "نوکری کی تلاش",
    Retired: "ریٹائرڈ",
    Homemaker: "گھر کی دیکھ بھال کرنے والی",
    submit: "جمع کریں"
  } , Punjabi:{
    whatYouLike: "ਤੁਸੀਂ ਕੀ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ?",
    option1:
      "ਕੀ ਤੁਸੀਂ ਬਿਨਾਂ ਕਿਸੇ ਨਿਵੇਸ਼ ਦੇ ਵਪਾਰ ਕਰਕੇ ਪੈਸਾ ਕਮਾਉਣਾ ਚਾਹੁੰਦੇ ਹੋ?",
    option2:
      "ਕੀ ਤੁਸੀਂ ਆਪਣੇ ਮੌਜੂਦਾ ਵਪਾਰ ਵਿੱਚ ਸੁਧਾਰ ਲਈ ਸਾਡੀ ਸਲਾਹ ਲੈਣਾ ਚਾਹੁੰਦੇ ਹੋ?",
    CurrentlyDoing: "ਤੁਸੀਂ ਹੁਣ ਕੀ ਕਰ ਰਹੇ ਹੋ?",
    Business: "ਵਪਾਰ",
    PrivateJob: "ਨਿੱਜੀ ਨੌਕਰੀ",
    GovermentJob: "ਸਰਕਾਰੀ ਨੌਕਰੀ",
    Student: "ਵਿਦਿਆਰਥੀ",
    SearchJob: "ਨੌਕਰੀ ਦੀ ਤਲਾਸ਼",
    Retired: "ਪੰਨਤੀ",
    Homemaker: "ਘਰ ਦੀ ਮਾਲਕਾ",
    submit: "ਸਬਮਿਟ"
  } , Malayalam: {
    whatYouLike: "നിങ്ങൾ എന്ത് ചെയ്യാൻ ആഗ്രഹിക്കുന്നു?",
    option1:
      "നിക്ഷേപം ഇല്ലാതെ ബിസിനസ്സ് ചെയ്ത് പണം സമ്പാദിക്കാൻ നിങ്ങൾ ആഗ്രഹിക്കുന്നുണ്ടോ?",
    option2:
      "നിങ്ങളുടെ നിലവിലുള്ള ബിസിനസ്സ് മെച്ചപ്പെടുത്താൻ ഞങ്ങളുടെ ഉപദേശം ലഭിക്കാൻ ആഗ്രഹിക്കുന്നുണ്ടോ?",
    CurrentlyDoing: "നിങ്ങൾ ഇപ്പോൾ എന്ത് ചെയ്യുന്നു?",
    Business: "വ്യാപാരം",
    PrivateJob: "സ്വകാര്യ ജോലി",
    GovermentJob: "സർക്കാരി ജോലി",
    Student: "വിദ്യാർത്ഥി",
    SearchJob: "ജോലി അന്വേഷിക്കുന്നു",
    Retired: "സമ്പൂര്‍ണ്ണമായത്",
    Homemaker: "ഗൃഹിണി",
    submit: "സമർപ്പിക്കുക"
  }
  , Odia:{
    whatYouLike: "ଆପଣ କଣ କରିବାକୁ ଚାହାନ୍ତି?",
    option1:
      "ଆପଣ କୌଣସି ନିବେଶ ଛଡ଼ା ବ୍ୟବସାୟ କରି ଟଙ୍କା ଅର୍ଜନ କରିବାକୁ ଚାହାନ୍ତି କି?",
    option2:
      "ଆପଣ ଆପଣଙ୍କର ବର୍ତ୍ତମାନ ବ୍ୟବସାୟକୁ ଉନ୍ନତ କରିବା ପାଇଁ ଆମ ସଲାହ ଚାହାନ୍ତି କି?",
    CurrentlyDoing: "ଆପଣ ବର୍ତ୍ତମାନ କଣ କରୁଛନ୍ତି?",
    Business: "ବ୍ୟବସାୟ",
    PrivateJob: "ନିଜୀ କାମ",
    GovermentJob: "ସରକାରୀ କାମ",
    Student: "ଛାତ୍ର/ଛାତ୍ରୀ",
    SearchJob: "ନୋକରୀ ଖୋଜୁଛନ୍ତି",
    Retired: "ବିଶ୍ରାମ",
    Homemaker: "ଘର ଚାଲାଣ କରୁଥିବା",
    submit: "ସମର୍ପିତ"
  }
  , Kannada: {
    whatYouLike: "ನೀವು ಏನು ಮಾಡಲು ಇಚ್ಛಿಸುತ್ತೀರಿ?",
    option1:
      "ನೀವು ಯಾವುದೇ ಹೂಡಿಕೆಯಾಗದೆ ವ್ಯವಹಾರ ಮಾಡುವ ಮೂಲಕ ಹಣ ಸಂಪಾದಿಸಲು ಇಚ್ಛಿಸುತ್ತೀರಾ?",
    option2:
      "ನಿಮ್ಮ ಪ್ರಸ್ತುತ ವ್ಯವಹಾರವನ್ನು ಸುಧಾರಿಸಲು ನಮ್ಮ ಸಲಹೆಗಳನ್ನು ಪಡೆಯಲು ಇಚ್ಛಿಸುತ್ತೀರಾ?",
    CurrentlyDoing: "ನೀವು ಈಗ ಏನು ಮಾಡುತ್ತಿದ್ದಾರೆ?",
    Business: "ವ್ಯವಹಾರ",
    PrivateJob: "ಖಾಸಗಿ ಕೆಲಸ",
    GovermentJob: "ಸರ್ಕಾರಿ ಕೆಲಸ",
    Student: "ವಿದ್ಯಾರ್ಥಿ",
    SearchJob: "ಕೆಲಸದ ಹುಡುಕಾಟ",
    Retired: "ಅನುವೃತ್ತಿ",
    Homemaker: "ಗೃಹಿಣಿ",
    submit: "ಸಮರ್ಪಿಸಿ"
  }
  , Assamese:{
    whatYouLike: "আপুনি কি কৰিবলৈ ইচ্ছা কৰে?",
    option1:
      "আপুনি বিনা বিনিয়োগত ব্যৱসায় কৰি ধন উপাৰ্জন কৰিবলৈ বিচাৰে নে?",
    option2:
      "আপোনাৰ বৰ্তমান ব্যৱসায় উন্নত কৰাৰ বাবে আমাৰ পৰামৰ্শ বিচাৰে নে?",
    "CurrentlyDoing": "আপুনি বৰ্তমান কি কৰি আছেন?",
    "Business": "ব্যৱসায়",
    "PrivateJob": "বেসৰকাৰী চাকৰি",
    "GovermentJob": "সরকাৰী চাকৰি",
    "Student": "ছাত্ৰ",
    "SearchJob": "চাকৰিৰ সন্ধান",
    "Retired": "অবসরপ্ৰাপ্ত",
    "Homemaker": "গৃহিণী",
    "submit": "জমা দিয়ক"
  },  
  Arabic: {
    whatYouLike: "ماذا ترغب أن تفعل؟",
    option1: "هل ترغب في كسب المال من خلال ممارسة الأعمال دون أي استثمار؟",
    option2:
      "هل ترغب في الحصول على نصيحتنا لتحسين عملك الحالي وتحقيق النجاح؟",
    CurrentlyDoing: 'ماذا تعمل حالياً؟',
    Business: 'أعمال تجارية',
    PrivateJob: 'وظيفة خاصة',
    GovermentJob: 'وظيفة حكومية',
    Student: 'طالب',
    SearchJob: 'أبحث عن وظيفة',
    Retired: 'متقاعد',
    Homemaker: 'ربة منزل',
    submit: 'إرسال'
  },
  Thai: {
    whatYouLike: "คุณต้องการทำอะไร?",
    option1: "คุณต้องการหารายได้โดยไม่ต้องลงทุนใช่หรือไม่?",
    option2:
      "คุณต้องการคำแนะนำจากเราเพื่อปรับปรุงและประสบความสำเร็จในธุรกิจของคุณหรือไม่?",
    CurrentlyDoing: 'คุณกำลังทำอะไรอยู่ในปัจจุบัน?',
    Business: 'ธุรกิจ',
    PrivateJob: 'งานเอกชน',
    GovermentJob: 'งานราชการ',
    Student: 'นักเรียน',
    SearchJob: 'หางาน',
    Retired: 'เกษียณแล้ว',
    Homemaker: 'แม่บ้าน',
    submit: 'ส่ง'
  },
  Filipino: {
    whatYouLike: "Ano ang gusto mong gawin?",
    option1:
      "Gusto mo bang kumita ng pera sa pamamagitan ng pagnenegosyo nang walang puhunan?",
    option2:
      "Gusto mo bang makatanggap ng payo mula sa amin upang mapabuti at magtagumpay sa iyong kasalukuyang negosyo?",
    CurrentlyDoing: 'Ano ang ginagawa mo sa kasalukuyan?',
    Business: 'Negosyo',
    PrivateJob: 'Pribadong trabaho',
    GovermentJob: 'Gobyernong trabaho',
    Student: 'Mag-aaral',
    SearchJob: 'Naghahanap ng trabaho',
    Retired: 'Retirado',
    Homemaker: 'Gumagawa sa bahay',
    submit: 'Isumite'
  },
  French: {
    whatYouLike: "Que souhaitez-vous faire ?",
    option1:
      "Souhaitez-vous gagner de l’argent en créant une entreprise sans aucun investissement ?",
    option2:
      "Souhaitez-vous recevoir nos conseils pour améliorer et réussir votre entreprise actuelle ?",
    CurrentlyDoing: 'Que faites-vous actuellement ?',
    Business: 'Affaires',
    PrivateJob: 'Emploi privé',
    GovermentJob: 'Emploi gouvernemental',
    Student: 'Étudiant',
    SearchJob: 'À la recherche d’un emploi',
    Retired: 'Retraité',
    Homemaker: 'Femme / Homme au foyer',
    submit: 'Soumettre'
  },
  Nepali: {
    whatYouLike: "तपाईं के गर्न चाहनुहुन्छ?",
    option1: "के तपाईं कुनै पनि लगानी बिना व्यापार गरेर पैसा कमाउन चाहनुहुन्छ?",
    option2:
      "के तपाईं आफ्नो वर्तमान व्यवसाय सुधार गर्न हाम्रो सल्लाह लिन चाहनुहुन्छ?",
    CurrentlyDoing: 'तपाईं अहिले के गर्दै हुनुहुन्छ?',
    Business: 'व्यवसाय',
    PrivateJob: 'निजी जागिर',
    GovermentJob: 'सरकारी जागिर',
    Student: 'विद्यार्थी',
    SearchJob: 'रोजगारी खोज्दै',
    Retired: 'सेवानिवृत्त',
    Homemaker: 'गृहिणी',
    submit: 'बुझाउनुहोस्'
  }
};

  export
  const userInformation: Record<string, any> = {
    English: {
      title: 'Get in Touch',
      financeDevelopment: 'Ready to improve your financial skills together?',
      purchase: 'Want to grab world-class products at a great discount?',
      joinWithUs: 'Interested in enhancing your life by joining Ariseupp7',
      firstName: 'Enter First Name *',
      lastName: 'Enter Last Name',
      gender: 'Gender*',
      male: 'Male',
      female: 'Female',
      dateOfBirth: 'Date of Birth',
      other: 'Others',
      email: 'Enter email',
      contact: 'Enter Mobile number',
      city: 'Enter Current City of Residence',
      district: 'Enter District Name',
      state: 'Enter State Name',
      pincode: 'Enter pincode',
      about: 'About yourself',
      agreement: 'Yes, I agree with the ',
      policy: 'privacy policy',
      submit: 'Submit',
      reset: 'Reset',
      agreeAlert: 'You must agree to the policy before submitting.'
    }, Hindi: {
      title: 'संपर्क करें',
      financeDevelopment: 'क्या आप अपने वित्तीय कौशल को बेहतर बनाना चाहते हैं?',
      purchase: 'क्या आप बेहतरीन छूट पर विश्व स्तरीय उत्पाद खरीदना चाहते हैं?',
      joinWithUs: 'क्या आप Ariseupp7 से जुड़कर अपना जीवन सुधारना चाहते हैं?',
      firstName: 'पहला नाम दर्ज करें *',
      lastName: 'अंतिम नाम दर्ज करें',
      gender: 'लिंग*',
      male: 'पुरुष',
      female: 'महिला',
      dateOfBirth: 'जन्म तिथि',
      other: 'अन्य',
      email: 'ईमेल दर्ज करें',
      contact: 'मोबाइल नंबर दर्ज करें',
      city: 'निवास का वर्तमान शहर',
      district: 'ज़िले का नाम',
      state: 'राज्य का नाम',
      pincode: 'पिनकोड दर्ज करें',
      about: 'अपने बारे में बताएं',
      agreement: 'हाँ, मैं इससे सहमत हूं ',
      policy: 'गोपनीयता नीति',
      submit: 'जमा करें',
      reset: 'रीसेट करें',
      agreeAlert: 'सबमिट करने से पहले आपको नीति से सहमत होना होगा।'
    },  Telugu: {
      title: 'మమ్మల్ని సంప్రదించండి',
      financeDevelopment: 'మీ ఆర్థిక నైపుణ్యాలను మెరుగుపరచడానికి సిద్ధంగా ఉన్నారా?',
      purchase: 'అద్భుతమైన డిస్కౌంట్‌తో ప్రీమియం ఉత్పత్తులను కొనాలనుకుంటున్నారా?',
      joinWithUs: 'Ariseupp7లో చేరి మీ జీవితం మెరుగుపరచాలనుకుంటున్నారా?',
      firstName: 'మొదటి పేరు నమోదు చేయండి *',
      lastName: 'చివరి పేరు నమోదు చేయండి',
      gender: 'లింగం*',
      male: 'పురుషుడు',
      female: 'స్త్రీ',
      other: 'ఇతరులు',
      email: 'ఇమెయిల్ నమోదు చేయండి',
      contact: 'మొబైల్ నంబర్ నమోదు చేయండి',
      city: 'ప్రస్తుత నివాస నగరం నమోదు చేయండి',
      district: 'జిల్లా పేరు',
      state: 'రాష్ట్ర పేరు',
      pincode: 'పిన్‌కోడ్ నమోదు చేయండి',
      about: 'మీ గురించి',
      agreement: 'అవును, నేను ',
      policy: 'గోప్యతా విధానం',
      submit: 'సమర్పించండి',
      reset: 'రిసెట్ చేయండి',
      agreeAlert: 'సమర్పించడానికి ముందు మీరు విధానానికి అంగీకరించాలి.'
    },  Bengali: {
      title: 'যোগাযোগ করুন',
      financeDevelopment: 'আপনি কি আপনার আর্থিক দক্ষতা উন্নত করতে প্রস্তুত?',
      purchase: 'বিশ্বমানের পণ্য সাশ্রয়ে কিনতে চান?',
      joinWithUs: 'Ariseupp7 এ যোগ দিয়ে নিজের জীবন উন্নত করতে চান?',
      firstName: 'প্রথম নাম লিখুন *',
      lastName: 'শেষ নাম লিখুন',
      gender: 'লিঙ্গ*',
      male: 'পুরুষ',
      female: 'মহিলা',
      other: 'অন্যান্য',
      email: 'ইমেইল লিখুন',
      contact: 'মোবাইল নম্বর লিখুন',
      city: 'বর্তমান শহরের নাম',
      district: 'জেলার নাম',
      state: 'রাজ্যের নাম',
      pincode: 'পিনকোড লিখুন',
      about: 'নিজের সম্পর্কে',
      agreement: 'হ্যাঁ, আমি সম্মত ',
      policy: 'গোপনীয়তা নীতি',
      submit: 'জমা দিন',
      reset: 'রিসেট করুন',
      agreeAlert: 'জমা দেওয়ার আগে আপনাকে নীতির সাথে সম্মত হতে হবে।'
    }, Tamil: {
      title: 'எங்களை தொடர்பு கொள்ளுங்கள்',
      financeDevelopment: 'உங்களின் நிதி திறன்களை மேம்படுத்த தயாரா?',
      purchase: 'உலக தரமான பொருட்களை சிறந்த தள்ளுபடியில் வாங்க விரும்புகிறீர்களா?',
      joinWithUs: 'Ariseupp7-இல் சேர்ந்து உங்கள் வாழ்க்கையை மேம்படுத்த விரும்புகிறீர்களா?',
      firstName: 'முதல் பெயரை உள்ளிடவும் *',
      lastName: 'கடைசி பெயரை உள்ளிடவும்',
      gender: 'பாலினம்*',
      male: 'ஆண்',
      female: 'பெண்',
      other: 'மற்றவை',
      email: 'மின்னஞ்சலை உள்ளிடவும்',
      contact: 'மொபைல் எண்ணை உள்ளிடவும்',
      city: 'தற்போதைய நகரம்',
      district: 'மாவட்டத்தின் பெயர்',
      state: 'மாநிலத்தின் பெயர்',
      pincode: 'அஞ்சல் குறியீட்டை உள்ளிடவும்',
      about: 'உங்களை பற்றி',
      agreement: 'ஆம், நான் ',
      policy: 'தனியுரிமைக் கொள்கை',
      submit: 'சமர்ப்பிக்கவும்',
      reset: 'மீட்டமை',
      agreeAlert: 'சமர்ப்பிக்குமுன் கொள்கையை ஒப்புக்கொள்ள வேண்டும்.'
    },  Marathi: {
      title: 'आमच्याशी संपर्क साधा',
      financeDevelopment: 'आपल्या आर्थिक कौशल्यात सुधारणा करण्यास तयार आहात का?',
      purchase: 'आपण जागतिक दर्जाच्या उत्पादनांना सवलतीत विकत घ्यायचे आहे का?',
      joinWithUs: 'Ariseupp7 मध्ये सामील होऊन आपले जीवन सुधारण्याची इच्छा आहे का?',
      firstName: 'पहिले नाव लिहा *',
      lastName: 'आडनाव लिहा',
      gender: 'लिंग*',
      male: 'पुरुष',
      female: 'स्त्री',
      other: 'इतर',
      email: 'ईमेल लिहा',
      contact: 'मोबाईल क्रमांक लिहा',
      city: 'सध्याचे शहर',
      district: 'जिल्ह्याचे नाव',
      state: 'राज्याचे नाव',
      pincode: 'पिनकोड लिहा',
      about: 'स्वतःबद्दल',
      agreement: 'हो, मी सहमत आहे ',
      policy: 'गोपनीयता धोरण',
      submit: 'सबमिट करा',
      reset: 'रीसेट करा',
      agreeAlert: 'सबमिट करण्यापूर्वी तुम्हाला धोरणास सहमती द्यावी लागेल.'
    }, Gujarati: {
      title: 'અમારો સંપર્ક કરો',
      financeDevelopment: 'શું તમે તમારું નાણાકીય કુશળતા સુધારવા તૈયાર છો?',
      purchase: 'શું તમે શ્રેષ્ઠ ડિસ્કાઉન્ટમાં વર્લ્ડ ક્લાસ પ્રોડક્ટ્સ ખરીદવા માંગો છો?',
      joinWithUs: 'Ariseupp7 સાથે જોડાઈને તમારું જીવન સુધારવા માંગો છો?',
      firstName: 'પ્રથમ નામ દાખલ કરો *',
      lastName: 'છેલ્લું નામ દાખલ કરો',
      gender: 'લિંગ*',
      male: 'પુરુષ',
      female: 'મહિલા',
      other: 'અન્ય',
      email: 'ઇમેઇલ દાખલ કરો',
      contact: 'મોબાઇલ નંબર દાખલ કરો',
      city: 'વર્તમાન શહેર',
      district: 'જિલ્લાનું નામ',
      state: 'રાજ્યનું નામ',
      pincode: 'પિનકોડ દાખલ કરો',
      about: 'તમારા વિશે',
      agreement: 'હા, હું સહમત છું ',
      policy: 'ગોપનીયતા નીતિ',
      submit: 'સબમિટ કરો',
      reset: 'રીસેટ કરો',
      agreeAlert: 'સબમિટ કરતા પહેલા તમારે નીતિ સાથે સહમત થવું પડશે.'
    }, Urdu: {
      title: 'ہم سے رابطہ کریں',
      financeDevelopment: 'کیا آپ اپنی مالی مہارت کو بہتر بنانے کے لیے تیار ہیں؟',
      purchase: 'کیا آپ عالمی معیار کی مصنوعات کو بہترین رعایت پر خریدنا چاہتے ہیں؟',
      joinWithUs: 'کیا آپ Ariseupp7 میں شامل ہو کر اپنی زندگی بہتر بنانا چاہتے ہیں؟',
      firstName: 'پہلا نام درج کریں *',
      lastName: 'آخری نام درج کریں',
      gender: 'جنس*',
      male: 'مرد',
      female: 'عورت',
      other: 'دیگر',
      email: 'ای میل درج کریں',
      contact: 'موبائل نمبر درج کریں',
      city: 'موجودہ شہر درج کریں',
      district: 'ضلع کا نام',
      state: 'صوبہ کا نام',
      pincode: 'پوسٹل کوڈ درج کریں',
      about: 'اپنے بارے میں',
      agreement: 'ہاں، میں اتفاق کرتا ہوں ',
      policy: 'پرائیویسی پالیسی',
      submit: 'جمع کریں',
      reset: 'ری سیٹ کریں',
      agreeAlert: 'جمع کرانے سے پہلے آپ کو پالیسی سے اتفاق کرنا ہوگا۔'
    },  Punjabi: {
      title: 'ਸਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰੋ',
      financeDevelopment: 'ਕੀ ਤੁਸੀਂ ਆਪਣੀਆਂ ਵਿੱਤੀ ਹੁਨਰਾਂ ਨੂੰ ਬਿਹਤਰ ਬਣਾਉਣ ਲਈ ਤਿਆਰ ਹੋ?',
      purchase: 'ਕੀ ਤੁਸੀਂ ਸੰਸਾਰ ਪੱਧਰੀ ਉਤਪਾਦ ਵਧੀਆ ਛੂਟ \'ਤੇ ਖਰੀਦਣਾ ਚਾਹੁੰਦੇ ਹੋ?',
      joinWithUs: 'ਕੀ ਤੁਸੀਂ Ariseupp7 ਵਿੱਚ ਸ਼ਾਮਲ ਹੋ ਕੇ ਆਪਣੀ ਜ਼ਿੰਦਗੀ ਬਿਹਤਰ ਬਣਾਉਣਾ ਚਾਹੁੰਦੇ ਹੋ?',
      firstName: 'ਪਹਿਲਾ ਨਾਂ ਦਰਜ ਕਰੋ *',
      lastName: 'ਆਖਰੀ ਨਾਂ ਦਰਜ ਕਰੋ',
      gender: 'ਲਿੰਗ*',
      male: 'ਮਰਦ',
      female: 'ਔਰਤ',
      other: 'ਹੋਰ',
      email: 'ਈਮੇਲ ਦਰਜ ਕਰੋ',
      contact: 'ਮੋਬਾਈਲ ਨੰਬਰ ਦਰਜ ਕਰੋ',
      city: 'ਮੌਜੂਦਾ ਸ਼ਹਿਰ ਦਰਜ ਕਰੋ',
      district: 'ਜ਼ਿਲ੍ਹੇ ਦਾ ਨਾਂ ਦਰਜ ਕਰੋ',
      state: 'ਰਾਜ ਦਾ ਨਾਂ ਦਰਜ ਕਰੋ',
      pincode: 'ਪਿੰਨ ਕੋਡ ਦਰਜ ਕਰੋ',
      about: 'ਆਪਣੇ ਬਾਰੇ ਲਿਖੋ',
      agreement: 'ਹਾਂ, ਮੈਂ ',
      policy: 'ਪਰਦੇਦਾਰੀ ਨੀਤੀ',
      submit: 'ਜਮ੍ਹਾਂ ਕਰੋ',
      reset: 'ਰੀਸੈੱਟ ਕਰੋ',
      agreeAlert: 'ਸਬਮਿਟ ਕਰਨ ਤੋਂ ਪਹਿਲਾਂ ਤੁਹਾਨੂੰ ਨੀਤੀ ਨਾਲ ਸਹਿਮਤ ਹੋਣਾ ਲਾਜ਼ਮੀ ਹੈ।'
    }, Malayalam: {
      title: 'ഞങ്ങളുമായി ബന്ധപ്പെടുക',
      financeDevelopment: 'നിങ്ങളുടെ സാമ്പത്തിക ശേഷി മെച്ചപ്പെടുത്താൻ തയ്യാറാണോ?',
      purchase: 'മികച്ച ഡിസ്‌ക്കൗണ്ടിൽ ലോക നിലവാരത്തിലുള്ള ഉൽപ്പന്നങ്ങൾ വാങ്ങാൻ ആഗ്രഹിക്കുന്നുവോ?',
      joinWithUs: 'Ariseupp7-ലിൽ ചേർന്ന് നിങ്ങളുടെ ജീവിതം മെച്ചപ്പെടുത്താൻ ആഗ്രഹിക്കുന്നുവോ?',
      firstName: 'ആദ്യ പേരു നൽകുക *',
      lastName: 'അവസാന പേരു നൽകുക',
      gender: 'ലിംഗം*',
      male: 'ആൺ',
      female: 'പെൺ',
      other: 'മറ്റുള്ളവർ',
      email: 'ഇമെയിൽ നൽകുക',
      contact: 'മൊബൈൽ നമ്പർ നൽകുക',
      city: 'നിലവിലുള്ള നഗരം',
      district: 'ജില്ലയുടെ പേര്',
      state: 'സംസ്ഥാനത്തിന്റെ പേര്',
      pincode: 'പിൻകോഡ് നൽകുക',
      about: 'നിങ്ങളെക്കുറിച്ച്',
      agreement: 'അതെ, ഞാൻ ',
      policy: 'സ്വകാര്യതാ നയം',
      submit: 'സമർപ്പിക്കുക',
      reset: 'പുനഃസജ്ജമാക്കുക',
      agreeAlert: 'സമർപ്പിക്കുന്നതിന് മുമ്പ് നിങ്ങൾ നയവുമായി സമ്മതിക്കണം.'
    }, Odia: {
      title: 'ଆମ ସହ ଯୋଗାଯୋଗ କରନ୍ତୁ',
      financeDevelopment: 'ଆପଣ ଆପଣଙ୍କର ଆର୍ଥିକ ଦକ୍ଷତା ବୃଦ୍ଧି କରିବାକୁ ପ୍ରସ୍ତୁତ ଅଛନ୍ତି କି?',
      purchase: 'ଆପଣ କି ଶ୍ରେଷ୍ଠ ଡିସ୍‌କାଉଣ୍ଟରେ ବିଶ୍ୱ ଶ୍ରେଷ୍ଠ ଉତ୍ପାଦ ଦେଖିବାକୁ ଚାହାନ୍ତି?',
      joinWithUs: 'Ariseupp7 ସହ ଯୋଗ ଦେଇ ଆପଣଙ୍କ ଜୀବନ ବୃଦ୍ଧି କରିବାକୁ ଚାହାନ୍ତି କି?',
      firstName: 'ପ୍ରଥମ ନାମ ଦିଅନ୍ତୁ *',
      lastName: 'ଶେଷ ନାମ ଦିଅନ୍ତୁ',
      gender: 'ଲିଙ୍ଗ*',
      male: 'ପୁରୁଷ',
      female: 'ମହିଳା',
      other: 'ଅନ୍ୟମାନେ',
      email: 'ଇମେଲ୍ ଦିଅନ୍ତୁ',
      contact: 'ମୋବାଇଲ୍ ନମ୍ବର ଦିଅନ୍ତୁ',
      city: 'ବର୍ତ୍ତମାନ ନଗର',
      district: 'ଜିଲ୍ଲା ନାମ',
      state: 'ରାଜ୍ୟ ନାମ',
      pincode: 'ପିନ୍‌କୋଡ୍ ଦିଅନ୍ତୁ',
      about: 'ଆପଣଙ୍କ ବିଷୟରେ',
      agreement: 'ହଁ, ମୁଁ ଏହା ସହିତ ସମ୍ମତ',
      policy: 'ଗୋପନୀୟତା ନୀତି',
      submit: 'ଦାଖଲ କରନ୍ତୁ',
      reset: 'ପୁନଃସେଟ୍ କରନ୍ତୁ',
      agreeAlert: 'ଦାଖଲ କରିବା ପୂର୍ବରୁ ଆପଣଙ୍କୁ ନୀତି ସହିତ ସମ୍ମତି ଦେବା ଆବଶ୍ୟକ।'
    },  Kannada: {
      title: 'ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ',
      financeDevelopment: 'ನಿಮ್ಮ ಆರ್ಥಿಕ ನಿಪುಣತೆಯನ್ನು ಉತ್ತಮಪಡಿಸಲು ನೀವು ಸಿದ್ಧರಿದ್ದೀರಾ?',
      purchase: 'ಅತ್ಯುತ್ತಮ ರಿಯಾಯಿತಿಯಲ್ಲಿ ವಿಶ್ವ ಮಟ್ಟದ ಉತ್ಪನ್ನಗಳನ್ನು ಖರೀದಿಸಲು ಬಯಸುತ್ತೀರಾ?',
      joinWithUs: 'Ariseupp7 ಗೆ ಸೇರಿ ನಿಮ್ಮ ಜೀವನವನ್ನು ಉತ್ತಮಪಡಿಸಲು ಬಯಸುತ್ತೀರಾ?',
      firstName: 'ಮೊದಲ ಹೆಸರನ್ನು ನಮೂದಿಸಿ *',
      lastName: 'ಕೊನೆಯ ಹೆಸರನ್ನು ನಮೂದಿಸಿ',
      gender: 'ಲಿಂಗ*',
      male: 'ಪುರುಷ',
      female: 'ಹೆಣ್ಣು',
      other: 'ಇತರರು',
      email: 'ಇಮೇಲ್ ನಮೂದಿಸಿ',
      contact: 'ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ',
      city: 'ಪ್ರಸ್ತುತ ನಗರ',
      district: 'ಜಿಲ್ಲೆಯ ಹೆಸರು',
      state: 'ರಾಜ್ಯದ ಹೆಸರು',
      pincode: 'ಪಿನ್ ಕೋಡ್ ನಮೂದಿಸಿ',
      about: 'ನಿಮ್ಮ ಬಗ್ಗೆ',
      agreement: 'ಹೌದು, ನಾನು ',
      policy: 'ಗೌಪ್ಯತಾ ನೀತಿ',
      submit: 'ಸಲ್ಲಿಸಿ',
      reset: 'ಮರುಹೊಂದಿಸಿ',
      agreeAlert: 'ಸಲ್ಲಿಸುವ ಮೊದಲು ನೀವು ನೀತಿಗೆ ಒಪ್ಪಿಗೆಯಾಗಬೇಕು.'
    }, Assamese: {
      title: 'আমাক যোগাযোগ কৰক',
      financeDevelopment: 'আপুনি আপোনাৰ বিত্তীয় কৌশল উন্নত কৰিবলৈ সাজু নেকি?',
      purchase: 'আপুনি কি বিশ্বমানৰ সামগ্রী উত্তম ৰেহাইত কিনিব বিচাৰে?',
      joinWithUs: 'আপুনি কি Ariseupp7-ত যোগ দি আপোনাৰ জীৱন উন্নত কৰিব বিচাৰে?',
      firstName: 'প্ৰথম নাম দিয়ক *',
      lastName: 'অন্তিম নাম দিয়ক',
      gender: 'লিংগ*',
      male: 'পুৰুষ',
      female: 'মহিলা',
      other: 'অন্যান্য',
      email: 'ই-মেইল দিয়ক',
      contact: 'ম’বাইল নম্বৰ দিয়ক',
      city: 'বৰ্তমান ৰহবাস কৰা চহৰ',
      district: 'জিলা নাম',
      state: 'ৰাজ্য নাম',
      pincode: 'পিনকোড দিয়ক',
      about: 'নিজৰ বিষয়ে',
      agreement: 'হয়, মই একমত ',
      policy: 'গোপনীয়তা নীতি',
      submit: 'জমা দিয়ক',
      reset: 'পুনৰ সংহতি কৰক',
      agreeAlert: 'জমা দিয়াৰ আগতে আপুনি নীতিটোৰ সৈতে একমত হ’ব লাগিব।'
    }, Arabic: {
      title: 'تواصل معنا',
      financeDevelopment: 'هل أنت مستعد لتحسين مهاراتك المالية معنا؟',
      purchase: 'هل ترغب في الحصول على منتجات عالمية بسعر مخفض؟',
      joinWithUs: 'هل ترغب في تحسين حياتك من خلال الانضمام إلى Ariseupp7؟',
      firstName: 'أدخل الاسم الأول *',
      lastName: 'أدخل اسم العائلة',
      gender: 'الجنس*',
      male: 'ذكر',
      female: 'أنثى',
      other: 'أخرى',
      email: 'أدخل البريد الإلكتروني',
      contact: 'أدخل رقم الهاتف',
      city: 'أدخل المدينة الحالية',
      district: 'أدخل اسم المنطقة',
      state: 'أدخل اسم الولاية',
      pincode: 'أدخل الرمز البريدي',
      about: 'عن نفسك',
      agreement: 'نعم، أوافق على ',
      policy: 'سياسة الخصوصية',
      submit: 'إرسال',
      reset: 'إعادة تعيين',
      agreeAlert: 'يجب أن توافق على السياسة قبل الإرسال.'
    }, Thai: {
      title: 'ติดต่อเรา',
      financeDevelopment: 'คุณพร้อมที่จะพัฒนาทักษะการเงินของคุณหรือไม่?',
      purchase: 'ต้องการซื้อสินค้าระดับโลกในราคาลดพิเศษหรือไม่?',
      joinWithUs: 'สนใจยกระดับชีวิตของคุณด้วยการเข้าร่วม Ariseupp7 หรือไม่?',
      firstName: 'กรุณากรอกชื่อ *',
      lastName: 'กรอกนามสกุล',
      gender: 'เพศ*',
      male: 'ชาย',
      female: 'หญิง',
      other: 'อื่นๆ',
      email: 'กรอกอีเมล',
      contact: 'กรอกเบอร์โทร',
      city: 'กรอกเมืองปัจจุบัน',
      district: 'กรอกชื่ออำเภอ',
      state: 'กรอกชื่อจังหวัด',
      pincode: 'กรอกรหัสไปรษณีย์',
      about: 'เกี่ยวกับตัวคุณ',
      agreement: 'ใช่ ฉันยอมรับ ',
      policy: 'นโยบายความเป็นส่วนตัว',
      submit: 'ส่ง',
      reset: 'รีเซ็ต',
      agreeAlert: 'คุณต้องยอมรับนโยบายก่อนส่งข้อมูล'
    }, Filipino: {
      title: 'Makipag-ugnayan sa Amin',
      financeDevelopment: 'Handa ka bang pagbutihin ang iyong kakayahang pampinansyal?',
      purchase: 'Gusto mo bang makabili ng world-class na produkto sa diskwento?',
      joinWithUs: 'Interesado ka bang pagbutihin ang iyong buhay sa pamamagitan ng pagsali sa Ariseupp7?',
      firstName: 'Ilagay ang Unang Pangalan *',
      lastName: 'Ilagay ang Apelyido',
      gender: 'Kasarian*',
      male: 'Lalaki',
      female: 'Babae',
      other: 'Iba pa',
      email: 'Ilagay ang email',
      contact: 'Ilagay ang Mobile number',
      city: 'Ilagay ang Kasalukuyang Lungsod',
      district: 'Ilagay ang Distrito',
      state: 'Ilagay ang Estado',
      pincode: 'Ilagay ang pincode',
      about: 'Tungkol sa iyong sarili',
      agreement: 'Oo, sumasang-ayon ako sa ',
      policy: 'patakaran sa privacy',
      submit: 'Isumite',
      reset: 'I-reset',
      agreeAlert: 'Kailangan mong sumang-ayon sa patakaran bago isumite.'
    }, French: {
      title: 'Contactez-nous',
      financeDevelopment: 'Prêt à améliorer vos compétences financières avec nous ?',
      purchase: 'Envie de bénéficier de remises sur des produits de qualité ?',
      joinWithUs: 'Souhaitez-vous améliorer votre vie en rejoignant Ariseupp7 ?',
      firstName: 'Entrez le prénom *',
      lastName: 'Entrez le nom',
      gender: 'Genre*',
      male: 'Homme',
      female: 'Femme',
      other: 'Autre',
      email: 'Entrez l’email',
      contact: 'Entrez le numéro de téléphone',
      city: 'Entrez votre ville actuelle',
      district: 'Entrez le nom du district',
      state: 'Entrez le nom de l’état',
      pincode: 'Entrez le code postal',
      about: 'À propos de vous',
      agreement: 'Oui, j’accepte la ',
      policy: 'politique de confidentialité',
      submit: 'Soumettre',
      reset: 'Réinitialiser',
      agreeAlert: 'Vous devez accepter la politique avant de soumettre.'
    }, Nepali: {
      title: 'सम्पर्क गर्नुहोस्',
      financeDevelopment: 'हामीसँग आर्थिक सीप सुधार गर्न तयार हुनुहुन्छ?',
      purchase: 'के तपाईं छूटमा उत्कृष्ट उत्पादनहरू किन्न चाहनुहुन्छ?',
      joinWithUs: 'Ariseupp7 मा सामेल भएर आफ्नो जीवन सुधार्न चाहनुहुन्छ?',
      firstName: 'पहिलो नाम प्रविष्ट गर्नुहोस् *',
      lastName: 'थर प्रविष्ट गर्नुहोस्',
      gender: 'लिङ्ग*',
      male: 'पुरुष',
      female: 'महिला',
      other: 'अन्य',
      email: 'इमेल प्रविष्ट गर्नुहोस्',
      contact: 'मोबाइल नम्बर प्रविष्ट गर्नुहोस्',
      city: 'हालको शहर प्रविष्ट गर्नुहोस्',
      district: 'जिल्ला नाम प्रविष्ट गर्नुहोस्',
      state: 'प्रदेश नाम प्रविष्ट गर्नुहोस्',
      pincode: 'पिनकोड प्रविष्ट गर्नुहोस्',
      about: 'आफ्नो बारेमा',
      agreement: 'हो, म सहमत छु ',
      policy: 'गोपनीयता नीति',
      submit: 'पेश गर्नुहोस्',
      reset: 'रीसेट गर्नुहोस्',
      agreeAlert: 'पेश गर्नु अघि तपाईंले नीतिमा सहमति जनाउनुपर्छ।'
    }  
  };
